import getComponent from '../utils/get-component'

export default getComponent('f2 mt0 green fw3 mb3', 'h1')
